import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Insurer.ListPublic.IRequest;
type Response = Api.Core.Insurer.ListPublic.IResponse;
type Headers = Api.Core.Insurer.ListPublic.IHeaders;
const url = '/api/Public/Insurer';
export default async function insurerListPublicApi(req: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, req),
    headers: getDefaultHeaders(),
  });
}
